import styled from 'styled-components';
import colors from '@theme/colors';

export const Ul = styled.ul`
  background-color: ${colors.WHITE};
  color: ${colors.TEXT};
`;

export const Li = styled.li`
  list-style: none;
`;



// WEBPACK FOOTER //
// ./components/atoms/List.js